// Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import {
  Facebook,
  Instagram,
  Linkedin,
  Phone,
  Mail,
  MapPin,
  Send,
  Youtube
} from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section">
      <div className="footer-top-border"></div>
      <div className="footer-container">
        {/* Column 1: Brand & About */}
        <div className="footer-col brand-col">
          <div className="footer-logo-wrapper">
            <img
              src='https://res.cloudinary.com/drevfgyks/image/upload/v1735541518/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/Agarwood_4_n1leyn.png'
              className='footer-logo'
              alt='ANT Logo'
            />
          </div>
          <p className="brand-tagline">
            Harvesting innovation for a sustainable tomorrow. We empower farmers with technology and nature's wisdom.
          </p>
          <div className="social-icons">
            <a href="https://www.facebook.com/share/1CPFYSvCKj/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook"><Facebook size={20} /></a>
            <a href="https://www.instagram.com/amaravathi.naturotech/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram"><Instagram size={20} /></a>
            <a href="https://www.linkedin.com/in/amaravathi-naturotech-937543333/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn"><Linkedin size={20} /></a>
            <a href="https://www.youtube.com/@amaravathinaturotech" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Youtube"><Youtube size={20} /></a>
          </div>
        </div>

        {/* Column 2: Navigation */}
        <div className="footer-col nav-col">
          <h4 className="col-heading">EXPLORE</h4>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about-us">About Us</Link></li>
            <li><Link to="/crops-products">Our Products</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
            <li><Link to="/career">Careers</Link></li>
          </ul>
        </div>

        {/* Column 3: Contact */}
        <div className="footer-col contact-col">
          <h4 className="col-heading">VISIT US</h4>
          <ul className="contact-details">
            <li>
              <MapPin className="icon" size={18} />
              <span>
                MIG-648, 1st Floor, Shanthi Nilayam,<br />
                KPHB Colony, Hyderabad-500072
              </span>
            </li>
            <li>
              <Phone className="icon" size={18} />
              <span>+91 98666 72765</span>
            </li>
            <li>
              <Mail className="icon" size={18} />
              <span>amaravathinatural@gmail.com</span>
            </li>
          </ul>
        </div>

        {/* Column 4: Newsletter */}
        <div className="footer-col newsletter-col">
          <h4 className="col-heading">SUBSCRIBE</h4>
          <p className="newsletter-desc">
            Join our green community. Receive updates on sustainable farming.
          </p>
          <form className="newsletter-form" onSubmit={(e) => e.preventDefault()}>
            <div className="input-group">
              <input type="email" placeholder="Your email address" aria-label="Email" />
              <button type="submit" aria-label="Subscribe">
                <Send size={18} />
              </button>
            </div>
          </form>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="bottom-content">
          <p className="copyright">&copy; {currentYear} Amaravathi Naturo Tech Pvt Ltd.</p>
          <div className="legal-links">
            <Link to="/privacy-policy">Privacy</Link>
            <span className="separator">•</span>
            <Link to="/terms">Terms</Link>
            <span className="separator">•</span>
            <Link to="/Web-Developer-details">Credits</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
